<app-pageheader [Parent]="this">
  <button class="button is-primary"
          [ngClass]="{ 'is-loading': isDownloading }"
          [disabled]="isDownloading"
          (click)="generateAndBulkPrintPending()">
    <span class="icon"><i class="fa-regular fa-file-pdf"></i></span>
    <span>Generate & Download</span>
  </button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/citationnotices/searches"
  [AllowEdit]="false">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-subset-filter [Subsets]="getSubsets()" Subset="Pending"></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>

